import React,{useEffect, useState} from 'react'
import { Row, Col, Container } from "react-bootstrap";
import { getPosts } from "../../service/apiBackEnd";
import styles from "../index.module.css"
const Index = () => {
    const [posts, setPosts] = useState([]);
    
    useEffect(() => {
        const fetchPosts = async () => {
            const data = await getPosts("&per_page=100");
            setPosts(data);      
        };
        fetchPosts();
    }, []);
    console.log("POSTSSSSS", posts);
    
  return (
    <Container>
    <Row>
        <h1 className='mt-4'>Noticias</h1>
        {posts.map((post) => {
                const featuredImage = post._embedded?.['wp:featuredmedia']?.[0]?.source_url || '';
                return (
                    <>
                        <Col lg={4} md={6} sm={12} key={post.id}>
                            <div className={styles.mainNoticias}>
                                <a href={`/noticias/${post.id}`} key={post.id} >
                                    {featuredImage && <img src={featuredImage} alt={post.title.rendered} className={styles.mainImg} />}
                                    <h3 className='mt-3'>{post.title.rendered}</h3>
                                    <p dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }}></p>
                                </a>
                            </div>
                        </Col>
                    </>
                );
            })}
    </Row>
</Container>
  )
}

export default Index